import { popoverAnatomy } from '@chakra-ui/anatomy'
import { defineSlotRecipe } from '@chakra-ui/react'

export const modalSlotRecipe = defineSlotRecipe({
  slots: popoverAnatomy.keys,
  base: {
    //    dialog: {
    //   minHeight: 400,
    //   borderRadius: 3,
    // },
    header: {
      pt: 6,
    },
    footer: {
      mb: 2,
      justifyContent: 'start',
    },
  },
})

// import { modalAnatomy as parts } from '@chakra-ui/anatomy'
// import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
// const helper = createMultiStyleConfigHelpers(parts.keys)

// const baseStyle = helper.definePartsStyle({
//   dialog: {
//     minHeight: 400,
//     borderRadius: 3,
//   },
//   header: {
//     pt: 6,
//   },
//   footer: {
//     mb: 2,
//     justifyContent: 'start',
//   },
// })

// export const modalTheme = helper.defineMultiStyleConfig({
//   baseStyle,
// })
